// extracted by mini-css-extract-plugin
export default {"deductions-report-header":"ReportByLeaveType_deductions-report-header__gpulQ"};